import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cat_word",
  "use": "icon-cat_word-usage",
  "viewBox": "0 0 11.47 10.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.47 10.3\" id=\"icon-cat_word\"><title>Word</title><g id=\"icon-cat_word_图层_2\" data-name=\"图层 2\"><g id=\"icon-cat_word_图层_1-2\" data-name=\"图层 1\"><polygon points=\"6.22 7.97 6.22 3.88 8.55 3.88 8.55 2.92 2.92 2.92 2.92 3.88 5.25 3.88 5.25 7.97 6.22 7.97\" /><path d=\"M11.47.48A.52.52,0,0,0,10.92,0H.55A.52.52,0,0,0,0,.48V9.82a.52.52,0,0,0,.55.48H10.92a.52.52,0,0,0,.55-.48Zm-1,8.85H1V1H10.5Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol